import React, {useState, useEffect} from "react";
import {Row, Col, Space, Form, Button, Input} from "antd";
import "./SubObjectInjury.scss";
const config = [
  {
    title: "Mode of Injury",
    name: "ModeOfInjury",
    sub_objects: [
      {title: "Mechanical Sharp", name: "MechanicalSharp"},
      {title: "Mechanical Blunt", name: "MechanicalBlunt"},
      {title: "Acid", name: "Acid"},
      {title: "Alkali", name: "Alkali"},
      {title: "Radiation", name: "Radiation"},
      {title: "Thernal", name: "Thernal"},
      {title: "Electrical", name: "Electrical"},
    ],
  },
  {
    title: "Case Of Injury",
    name: "CaseOfInjury",
    sub_objects: [
      {title: "Occupational-Agriculture", name: "Occupational-Agriculture"},
      {title: "Occupational-Industrial", name: "Occupational-Industrial"},
      {title: "Road Traffic Accident", name: "RoadTrafficAccident"},
      {title: "Assault", name: "Assault"},
      {title: "Sports", name: "Sports"},
      {title: "Dosmestic", name: "Dosmestic"},
    ],
  },
];

const SubObjectInjury = () => {
  const [subObjs1, setSubObjs1] = useState<any>(config[0].sub_objects);
  const [subObjs2, setSubObjs2] = useState<any>(config[1].sub_objects);
  useEffect(() => {
    subObjs1.map(subObj1 => {
      return {...subObj1, show: false};
    });
    subObjs2.map(subObj2 => {
      return {...subObj2, show: false};
    });
  }, []);
  const setShowObject1 = subObj1 => {
    subObj1.show = !subObj1.show;
    setSubObjs1([...subObjs1]);
  };
  const setShowObject2 = subObj2 => {
    subObj2.show = !subObj2.show;
    setSubObjs2([...subObjs2]);
  };
  return (
    <div className="sub-object-injury">
      <Space direction="vertical">
        <Row>
          <Col flex={"150px"} style={{fontWeight: 600}}>
            {config[0].title}
          </Col>
          <Col flex={"auto"}>
            <Space>
              {subObjs1.map(subObj1 => (
                <Button
                  onClick={() => {
                    setShowObject1(subObj1);
                  }}
                  type={subObj1.show == true ? "primary" : "default"}
                >
                  {subObj1.name}
                </Button>
              ))}
            </Space>
          </Col>
        </Row>
        <Row>
          <Col flex={"150px"}></Col>
          <Col flex={"auto"}>
            <Row gutter={[16, 16]}>
              {subObjs1.map(subObj1 => {
                if (subObj1.show) {
                  return (
                    <Col xs={24} md={12} lg={8} xl={8}>
                      <Form.Item
                        label={subObj1.title}
                        name={[
                          "ChiefComplaints",
                          "Injury/Trauma",
                          "ModeOfInjury",
                          subObj1.name,
                        ]}
                      >
                        <Input></Input>
                      </Form.Item>
                    </Col>
                  );
                }
              })}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col flex={"150px"} style={{fontWeight: 600}}>
            {config[1].title}
          </Col>
          <Col flex={"auto"}>
            <Space>
              {subObjs2.map(subObj2 => (
                <Button
                  onClick={() => {
                    setShowObject2(subObj2);
                  }}
                  type={subObj2.show == true ? "primary" : "default"}
                >
                  {subObj2.name}
                </Button>
              ))}
            </Space>
          </Col>
        </Row>
        <Row>
          <Col flex={"150px"}></Col>
          <Col flex={"auto"}>
            <Row gutter={[16, 16]}>
              {subObjs2.map(subObj2 => {
                if (subObj2.show) {
                  return (
                    <Col xs={24} md={12} lg={8} xl={8}>
                      <Form.Item
                        label={subObj2.title}
                        name={[
                          "ChiefComplaints",
                          "Injury/Trauma",
                          "CaseOfInjury",
                          subObj2.name,
                        ]}
                      >
                        <Input></Input>
                      </Form.Item>
                    </Col>
                  );
                }
              })}
            </Row>
          </Col>
        </Row>
      </Space>
    </div>
  );
};
export default SubObjectInjury;
